/** Possible states when previewing the recorded audio */
export var PreviewState;
(function (PreviewState) {
    PreviewState[PreviewState["Loading"] = 0] = "Loading";
    PreviewState[PreviewState["Ready"] = 1] = "Ready";
    PreviewState[PreviewState["Playing"] = 2] = "Playing";
    PreviewState[PreviewState["Paused"] = 3] = "Paused";
    PreviewState[PreviewState["Error"] = 4] = "Error";
})(PreviewState || (PreviewState = {}));
/** Possible states when uploading the audio to S3 for adding to the checkout cart */
export var UploadingState;
(function (UploadingState) {
    UploadingState[UploadingState["Ready"] = 0] = "Ready";
    UploadingState[UploadingState["Uploading"] = 1] = "Uploading";
    UploadingState[UploadingState["Uploaded"] = 2] = "Uploaded";
    UploadingState[UploadingState["Error"] = 3] = "Error";
})(UploadingState || (UploadingState = {}));
